import Vue from "vue";
import VirtualList from "vue-virtual-scroll-list";
import BeautifulChat from "vue-beautiful-chat";
import { RecycleScroller } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import VueCropper from "vue-cropper";
import "./antd";
import "./material";
import "./swiper";
import { importAll } from "@/utils";

const requireContext = require.context("./", true, /\.vue$/);
const components = importAll(requireContext);

for (let key in components) {
  Vue.component(components[key].name, components[key]);
}

Vue.component("VirtualList", VirtualList);
Vue.component("RecycleScroller", RecycleScroller);
Vue.use(BeautifulChat);
Vue.use(VueCropper);
